












import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ImagemDeTabela extends Vue {
	@Prop({ type: String, default: '' }) src!: string
	@Prop({ type: String, default: 'Imagem' }) alt!: string
	@Prop({ type: [String, Number], default: 60 }) width!: string | number
	@Prop({ type: [String, Number], default: 60 }) height!: string | number
	@Prop({ type: String, default: 'Imagem não encontrada' }) textoSemImagem!: string

	imagensComErro: Set<string> = new Set()
}
